import {
  AT_LEAST_ONE_NUMBER_REGEX,
  AT_LEAST_ONE_SPECIAL_CHARACTER,
  AT_LEAST_ONE_UPPERCASE_LETTER,
} from '@/constants/password-regex.constants';

export const getPasswordRequirements = (value: string) => {
  return [
    { text: 'Minimum 8 characters', fulfilled: value.length >= 8 },
    { text: 'Minimum one uppercase letter', fulfilled: AT_LEAST_ONE_UPPERCASE_LETTER.test(value) },
    {
      text: 'Minimum one special character (!,@,#,$,% etc.)',
      fulfilled: AT_LEAST_ONE_SPECIAL_CHARACTER.test(value),
    },
    { text: 'Minimum one number', fulfilled: AT_LEAST_ONE_NUMBER_REGEX.test(value) },
  ];
};
